var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"rootEl",staticClass:"bottom-fixed",class:{
        'bottom-fixed--safe-area': _vm.shouldUseSafeArea,
        'bottom-fixed--keyboard-visible': _vm.staticOnKeyboard && _vm.keyboardVisible,
    },style:(_vm.bottomFixedStyle)},[(_vm.showMask)?_c('div',{ref:"maskEl",staticClass:"bottom-fixed__mask",class:{ hidden: _vm.isScrolledToBottom }}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bottom-fixed__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }